import { useEffect, useState } from "react";
import { useEvent } from "../../../../context/EventContext";

// This function component displays a preview of the event details such as name, type, description, location, venue, and capacity.
// It includes buttons for editing the event details and proceeding to the next step.
const MainEventPreview = ({ onEdit, onNext }) => {
  const { formData } = useEvent();
  const [daysLeft, setDaysLeft] = useState(null);

  useEffect(() => {
    if (formData.registration_start_date) {
      const registrationDate = new Date(formData.registration_start_date);
      const currentDate = new Date();

      // Reset the time part of both dates to only compare the day, month, and year
      registrationDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      // Calculate the difference in days
      const timeDiff = registrationDate.getTime() - currentDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

      setDaysLeft(() => {
        if (daysDiff < 0) {
          return "Registrations have already opened.";
        } else if (daysDiff === 0) {
          return "Registrations open today!";
        } else if (daysDiff === 1) {
          return "1 Day left for registrations to open";
        } else {
          return `${daysDiff} Days left for registrations to open`;
        }
      });
    }
  }, [formData.registration_start_date]);

  return (
    <div className="event-details">
      <h1>{daysLeft}</h1>
      <h2>{formData.event_name}</h2>
      <p>Type: {formData.event_type}</p>
      <p>Description: {formData.description}</p>
      <p>Location: {formData.location}</p>
      <p>Venue: {formData.venue_type}</p>
      <p>Capacity: {formData.capacity}</p>
      <button className="add-space" onClick={onEdit}>
        Edit Details
      </button>
      <button className="add-space" onClick={onNext}>
        Next
      </button>
    </div>
  );
};

export default MainEventPreview;
